import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface BrokerageSearchDTO extends BaseSearchDTO {
  filters?: {
    assignedToContactId?: string;
  };
}
